export const townSchema = {
	schema: {
		title: 'town schema',
		description: 'Town Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			towncode_c: {
				type: 'string',
			},
			towndescription_c: {
				type: 'string',
			},
		},
		required: ['id', 'towncode_c', 'towndescription_c'],
	},
};
